import { IHotelPreferenceCategory, ITimePeriod, IOfferCategory, INoteTopic } from "services/models";
import { IPreferencesApiService } from "services/models/ApiService";
import { delay } from "utils";
import { mockHotelStore } from "./hotelbooking-data";
import { mockPlayerDataStore } from "./player-data";

export class MockPreferencesApiService implements IPreferencesApiService {
  getPreferences(): Promise<IHotelPreferenceCategory[]> {
    return delay(() => {
      return mockHotelStore.groupedPreferences;
    });
  }

  getTimePeriod(): Promise<ITimePeriod[]> {
    return delay(() => {
      return [
        {
          id: "1",
          name: "1 Day",
          default: false,
        },
        {
          id: "7",
          name: "7 Days",
          default: true,
        },
        {
          id: "YTD",
          name: "Year-to-Date",
          default: false,
        },
      ];
    });
  }

  getOfferCategories(): Promise<IOfferCategory[]> {
    return delay(() => {
      return [
        {
          id: 0,
          name: "Slots",
        },
        {
          id: 2,
          name: "Dining",
        },
      ];
    });
  }

  getNoteTopics(): Promise<INoteTopic[]> {
    return delay(() => {
      return mockPlayerDataStore.topics;
    });
  }
}
